import { ACCOUNTING_THRESHOLD_BY_CURRENCY, RSS_ACCOUNTING_THRESHOLD_BY_CURRENCY } from "../components/constants";
import { type BusinessModelData } from "../types";

const isRssBusinessModel = (businessModel: BusinessModelData) => {
  return businessModel && !["ecommerce_dtc", "wholesale"].includes(businessModel);
};

export const getAccountingThreshold = (businessModel: BusinessModelData) => {
  return isRssBusinessModel(businessModel) ? RSS_ACCOUNTING_THRESHOLD_BY_CURRENCY : ACCOUNTING_THRESHOLD_BY_CURRENCY;
};

/* GA connection only required if no ecommerce or payments connectors selected */
